module.exports = __webpack_public_path__ + "9473864cad92fff96b0772968c6e1bbe.webp";